import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth/auth';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password.css',
})
export class ForgotPassword {
  private readonly auth = inject(AuthService);

  readonly submitting = signal(false);
  readonly submitted = signal(false);
  readonly errorMessage = signal<string | null>(null);

  readonly form = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
  });

  async submit(): Promise<void> {
    if (this.form.invalid || this.submitting()) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitting.set(true);
    this.errorMessage.set(null);
    try {
      // Always shows the same generic success state, matching the backend's
      // enumeration-safe response (200 regardless of whether the email
      // has an account).
      await this.auth.requestPasswordReset(this.form.getRawValue().email);
      this.submitted.set(true);
    } catch {
      this.errorMessage.set(
        'Something went wrong on our end — give it another try in a moment.',
      );
    } finally {
      this.submitting.set(false);
    }
  }
}
